import React from 'react';
import { motion } from 'framer-motion';
import { ScissorsIcon, SparklesIcon, SyringeIcon, HeartPulseIcon, EyeIcon, SmileIcon } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import { SERVICES } from '../../content/site';
import { EASE } from '../ui/Primitives';
const ICONS: Record<string, React.ElementType> = {
  liposuction: ScissorsIcon,
  tummy: SparklesIcon,
  breast: HeartPulseIcon,
  face: EyeIcon,
  injectables: SyringeIcon,
  contouring: SmileIcon
};
export function ServiceGrid({
  limit
}: {
  limit?: number;
}) {
  const {
    language
  } = useLanguage();
  const t = SERVICES[language];
  const items = limit ? t.services.slice(0, limit) : t.services;
  return <div className="grid gap-px overflow-hidden rounded-2xl border border-espresso/10 bg-espresso/10 sm:grid-cols-2 lg:grid-cols-3" data-id="element-95" data-mp="1kub6ilfkcwb7">
      {items.map((service, index) => {
      const Icon = ICONS[service.key] || SparklesIcon;
      return <motion.article key={service.key} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.6,
        delay: index * 0.07,
        ease: EASE
      }} className="group flex flex-col bg-white p-8 transition-colors duration-500 hover:bg-cream lg:p-10" data-id="element-96" data-mp="1ts3oxygl0k2t" data-mpi={index}>
            <div className="mb-7 text-espresso/25 transition-colors duration-500 group-hover:text-bronze" data-id="element-97" data-mp="3j4b5a2g2wll1">
              <Icon className="h-7 w-7" strokeWidth={1} data-id="element-98" data-mp="3s7c89u9ndwkh" />
            </div>
            <h3 className="mb-3 font-serif text-xl font-normal leading-snug text-espresso" data-id="element-99" data-mp="3s599olufiv45">
              {service.title}
            </h3>
            <p className="text-sm font-light leading-relaxed text-espresso/60" data-id="element-100" data-mp="5saqmgzlf2wl">
              {service.description}
            </p>
            <span aria-hidden="true" className="mt-7 h-px w-8 bg-bronze/40 transition-all duration-500 group-hover:w-14 group-hover:bg-bronze" data-id="element-101" data-mp="as5escrzhedy" />
          </motion.article>;
    })}
    </div>;
}